import { AnyAction } from 'redux';
import { IDialogState } from '.';
import { SortDirection } from '../../api/entities/page';
import { IShardClusterRequestParams, IShardClusterListItem, ShardClusterSortField } from "../../api/entities/shard-cluster";
import { IDeleteBlockedConfirmationDataV2 } from '../../components/shard-clusters/dialogs/delete-blocked-confirmation/delete-blocked-confirmation';
import { CREDENTIALS_INFO, DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME, DELETE_CONFIRMATION_DIALOG_NAME, SHARD_CLUSTER_ENTITY_NAME } from '../actions/shard-cluster';
import { createDialogReducer, DIALOG_DEFAULT_STATE } from './dialog';
import { createEntityReducer, getEntityDefaultState, IEntityState } from './entity';
import { IShardRepositoryCredentialsConfirmationData } from "../../api/entities/shard-repository";

export interface IShardClusterState extends IEntityState<IShardClusterListItem, ShardClusterSortField, IShardClusterRequestParams> {
  [DELETE_CONFIRMATION_DIALOG_NAME]: IDialogState<IShardClusterListItem>;
  [DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME]: IDialogState<IDeleteBlockedConfirmationDataV2>;
  [CREDENTIALS_INFO]: IDialogState<IShardRepositoryCredentialsConfirmationData>;
}

function getShardClusterDefaultState(sortField: string): IShardClusterState {
  return {
    [DELETE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
    [DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
    [CREDENTIALS_INFO]: DIALOG_DEFAULT_STATE,
    ...getEntityDefaultState(sortField, SortDirection.Ascending)
  }
}

const entityReducer = createEntityReducer(SHARD_CLUSTER_ENTITY_NAME);
const deleteConfirmationReducer = createDialogReducer(SHARD_CLUSTER_ENTITY_NAME, DELETE_CONFIRMATION_DIALOG_NAME);
const deleteBlockedConfirmationReducer = createDialogReducer(SHARD_CLUSTER_ENTITY_NAME, DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME);
const excessiveCredentialsConfirmationReducer = createDialogReducer(SHARD_CLUSTER_ENTITY_NAME, CREDENTIALS_INFO);

export function shardCluster(
  state: IShardClusterState = getShardClusterDefaultState(ShardClusterSortField.Name),
  action: AnyAction
): IShardClusterState {
  state = entityReducer(state, action);
  state = deleteConfirmationReducer(state, action);
  state = deleteBlockedConfirmationReducer(state, action);
  state = excessiveCredentialsConfirmationReducer(state, action);
  return state;
}
